import {
    LOAD_TRACKING_MAP_DATA,
    TRACKING_MAP_DATA_FAILURE,
    TRACKING_MAP_DATA_SUCCESS,
} from '../actions';

const initialState = {
    fetching: false,
    error: undefined,
    content: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_TRACKING_MAP_DATA:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case TRACKING_MAP_DATA_FAILURE:
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        case TRACKING_MAP_DATA_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: undefined,
                content: action.payload.content,
            };
        default:
            return state;
    }
};

export default reducer;
